export const BASE_URL = process.env.REACT_APP_FRANCHISEBX_BASE_URL;

// AUTH ENDPOINTS
export const endpoints = {
  SIGNUP_API: `${BASE_URL}/api/signup/`,
  LOGIN_API: `${BASE_URL}/api/login/`,
  BUSSINESS_API: `${BASE_URL}/api/businessdetail/`,
};

//CATEGORY SUB_CATEGORY

export const CATEGORY = {
  GET_CATEGORY: `${BASE_URL}/accounts/category/`,
  POST_CATEGORY: `${BASE_URL}/accounts/category/`,
};
//Trending Vedio
export const Trendingvedio = {
  GET_TRENDING_VEDIO: `${BASE_URL}/accounts/video/`,
};

//invester
export const Investers = {
  POST_INVESTER: `${BASE_URL}/api/investerdetail/`,
};
//ChannelPartner
export const ChannelPartner = {
  POST_CHHANEL_PARTNER: `${BASE_URL}/api/channelpartner/`,
};
//RaiseFund
export const RaiseFunds = {
  POST_RAISE_FUND: `${BASE_URL}/otherLeads/funds/`,
};
//Bussiness for loan
export const BusinessesLoan = {
  POST_BUSSINESS_LOAN: `${BASE_URL}/otherLeads/loan/`,
};
//Apply franchisor
export const Applyfranchisor = {
  POST_APPLY: `${BASE_URL}/api/applyfranchise/`,
};
//Startup
export const Startups = {
  GET_STARTUPS: `${BASE_URL}/accounts/startup/`,
};
//Contactstartup
export const Contactstartup = {
  POST_CONTACT: `${BASE_URL}/accounts/contactstratup/`,
};
//Upcoming Events
export const events = {
  POST_UPCOMING: `${BASE_URL}/accounts/events/`,
};
//Newsletter
export const Newsletter = {
  POST_NEWSLETTER_API: `${BASE_URL}/accounts/newsletter/`,
};

//Buysell
export const Buysell = {
  POST_BUYSELL: `${BASE_URL}/otherLeads/buysell/`,
};
//Countryapi
export const Countryapi = {
  GET_COUNTRY_API: `${BASE_URL}/accounts/countries/`,
};
//stateapi
export const Stateapi = {
  GET_STATE_API: `${BASE_URL}/accounts/states/`,
};
//Cityapi
export const Cityapi = {
  GET_CITY_API: `${BASE_URL}/accounts/city/`,
};
export const DashboardsEndpoints = {
  GET_FRANCHISE_API: `${BASE_URL}/api/businessdetail`,
};
export const TestimonialsEndpoints = {
  GET_TESTIMONIAL_API: `${BASE_URL}/accounts/testimonials`,
};
export const BlogsEndpoints = {
  GET_BLOGS_API: `${BASE_URL}/accounts/blogs`,
};
export const VideoEndpoints = {
  GET_VIDEO_API: `${BASE_URL}/accounts/video`,
};

export const InquirySolutionEndpoints = {
  POST_INQUIRY_API: `${BASE_URL}/api/inquire/`,
};

export const contactEndPoints = {
  POST_CONTACTUS_API: `${BASE_URL}/otherLeads/contactus/`,
};
export const faqsEndPoints = {
  GET_FAQS_API: `${BASE_URL}/otherLeads/faq/`,
};

export const comment = {
  POST_COMMENT: `${BASE_URL}/otherLeads/comment/`,
  GET_COMMENT: `${BASE_URL}/otherLeads/comment/`
}

export const reply = {
  POST_REPLY: `${BASE_URL}/otherLeads/Reply/`,
  GET_REPLY: `${BASE_URL}/otherLeads/Reply/`
}

//forget password
export const forgetpassword = {
  POST_FORGET_PASSWORD: `${BASE_URL}/accounts/forgot-password/`,
  POST_OTP: `${BASE_URL}/accounts/verify_otp/`,
  CONFIRM_PASSWORD: `${BASE_URL}/accounts/Password_Reset/`
}